import React from 'react';
import './TitleHeader.css';
import PropTypes from 'prop-types';

const TitleHeader = (props) => {
  const {
    title, subtitle, titleColor, subtitleColor,
  } = props;
  return (
    <div className="header">
      <div
        className="title1"
        style={{
          color: titleColor,
        }}
      >
        {title}
      </div>
      <div
        className="title2"
        style={{
          color: subtitleColor,
        }}
      >
        {subtitle}
      </div>
      <div className="delimiter" />
    </div>
  );
};

TitleHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  titleColor: PropTypes.string.isRequired,
  subtitleColor: PropTypes.string.isRequired,
};

export default TitleHeader;



// WEBPACK FOOTER //
// ./src/components/TitleHeader/TitleHeader.jsx